import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NewsPage from "./pages/NewsPage";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import NewsAdmin from "./pages/admin/NewsAdmin";
import ServicesAdmin from "./pages/admin/ServicesAdmin";
import PortfolioAdmin from "./pages/admin/PortfolioAdmin";
import DocumentsAdmin from "./pages/admin/DocumentsAdmin";
import ClientsAdmin from "./pages/admin/ClientsAdmin";
import SettingsAdmin from "./pages/admin/SettingsAdmin";
import AdminsAdmin from "./pages/admin/AdminsAdmin";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<NewsPage />} />

          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="news" element={<NewsAdmin />} />
            <Route path="services" element={<ServicesAdmin />} />
            <Route path="portfolio" element={<PortfolioAdmin />} />
            <Route path="documents" element={<DocumentsAdmin />} />
            <Route path="clients" element={<ClientsAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
            <Route path="admins" element={<AdminsAdmin />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
